import { Link, Outlet } from "@tanstack/react-router";
import { Activity, Cable, Cpu, LayoutGrid } from "lucide-react";

import { ThemeControls } from "./ThemeControls";

/**
 * Edge layout — a slimmed-down shell for the site-scoped LAN dashboard (X3).
 * No Rail (no fleet navigation), no capabilities gate, no auth — the edge node
 * is behind the site LAN and serves a single site. The nav is a flat tab bar
 * across the site screens.
 */
export function EdgeLayout() {
  const linkBase =
    "flex items-center gap-1.5 rounded px-3 py-1.5 text-sm focus:outline focus:outline-2 focus:outline-accent";
  const activeCls = "bg-surface-raised font-medium text-text";
  const inactiveCls = "text-text-muted hover:bg-surface-raised";

  return (
    <div className="flex h-screen flex-col bg-bg text-text">
      <header className="flex items-center gap-3 border-b border-border bg-surface px-density-pad py-2">
        <strong className="text-lg">SolarKey</strong>
        <span className="text-text-muted">Edge</span>

        <nav aria-label="Site" className="ml-4 flex gap-1">
          <Link
            to="/now"
            search={{ period: "today", mode: "live" }}
            className={linkBase}
            activeProps={{ className: activeCls }}
            inactiveProps={{ className: inactiveCls }}
          >
            <Activity aria-hidden size={14} />
            <span>Now</span>
          </Link>
          <Link
            to="/datapath"
            className={linkBase}
            activeProps={{ className: activeCls }}
            inactiveProps={{ className: inactiveCls }}
          >
            <Cable aria-hidden size={14} />
            <span>Data path</span>
          </Link>
          <Link
            to="/schematic"
            className={linkBase}
            activeProps={{ className: activeCls }}
            inactiveProps={{ className: inactiveCls }}
          >
            <LayoutGrid aria-hidden size={14} />
            <span>Schematic</span>
          </Link>
          <Link
            to="/sensors"
            className={linkBase}
            activeProps={{ className: activeCls }}
            inactiveProps={{ className: inactiveCls }}
          >
            <Cpu aria-hidden size={14} />
            <span>Sensors</span>
          </Link>
        </nav>

        <div className="ml-auto">
          <ThemeControls />
        </div>
      </header>

      <main className="min-w-0 flex-1 overflow-auto p-density-pad">
        <Outlet />
      </main>
    </div>
  );
}
